module.exports = __webpack_public_path__ + "static/img/newCode.b69412b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newCode.png
// module id = I3BH
// module chunks = 0